<h1 mat-dialog-title style="font-size: 30px;">Product Creation</h1>
<mat-dialog-content class="mat-typography">
  <div [formGroup]="form">
    <mat-form-field appearance="outline" color="primary" class="dialog-input">
      <mat-label>Product Barcode</mat-label>
      <input matInput formControlName="barcode">
      @if (form.get('barcode')?.hasError('serverError')) {
        <mat-error>
          {{validationMessage('barcode')}}
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" color="primary" class="dialog-input">
      <mat-label>Reference</mat-label>
      <input matInput formControlName="reference">
      @if (form.get('reference')?.hasError('serverError')) {
        <mat-error>
          {{validationMessage('reference')}}
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" color="primary" class="dialog-input">
      <mat-label>Description</mat-label>
      <input matInput formControlName="description">
      @if (form.get('description')?.hasError('serverError')) {
        <mat-error>
          {{validationMessage('description')}}
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" color="primary" class="dialog-input">
      <mat-label>Product Link</mat-label>
      <input matInput formControlName="productLink">
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>Cancel</button>
  <button mat-button (click)="createProduct()" #create color="buttonSuccess">Create</button>
</mat-dialog-actions>
